import T from '../../Locale';
export const AddressTypes = [
    { value: 'share', label: T.translate('values.addressType.share') },
    { value: 'owner', label: T.translate('values.addressType.owner') },
    { value: 'owner_abroad', label: T.translate('values.addressType.ownerAbroad') },
    { value: 'business', label: T.translate('values.addressType.business') },
    { value: 'house_boat', label: T.translate('values.addressType.houseBoat') },
    { value: 'allotment', label: T.translate('values.addressType.allotment') },
    { value: 'agriculture', label: T.translate('values.addressType.agriculture') },
    { value: 'cottage', label: T.translate('values.addressType.cottage') }
];
